import { init, browserTracingIntegration, captureConsoleIntegration } from "@sentry/vue";

/**
 *
 * @param {import("vue-router").Router} router
 * @returns {import("vue").FunctionPlugin}
 */
export function createSentry(router) {
  return function (app) {
    if (import.meta.env.SSR) return;
    init({
      app,
      dsn: "https://6264f92b540a7deca45384909bb0e522@o4511699948929024.ingest.de.sentry.io/4511700036157520",
      integrations: [browserTracingIntegration({ router }), captureConsoleIntegration({ levels: ["error"] })],
      ignoreErrors: [
        "AppError",
        "Cookie Control failed to verify your settings",
        "via a navigation guard",
        "Network Error",
        "There was an error setting cookie",
        "[vue-matomo] An error occurred trying to load",
      ],
      beforeSend(event, hint) {
        // Un <script> bloqué rejette avec un Event DOM sans message ni stack : seul target.src
        // identifie le script. Pas de console.error ici, captureConsoleIntegration le recapturerait.
        const reason = hint?.originalException;
        if (reason instanceof Event && reason.target instanceof HTMLScriptElement) {
          event.tags = { ...event.tags, script_src: reason.target.src };
        }
        return event;
      },
    });
  };
}
